<template>
    <div>
        <v-container fluid pa-0>
            <v-card elevation="0">
                <v-container fluid grid-list-xl class="toolbar-container">
                    <v-layout row wrap :class="$bp.smallScreen ? 'mx-0' : null">
                        <v-toolbar color="grey lighten-3" elevation="1">
                            <bc-btn-back></bc-btn-back>
                            <v-toolbar-title class="ml-0">{{ $t($route.meta.title) }}</v-toolbar-title>
                            <v-spacer></v-spacer>
                            <v-btn v-if="hasPerm('exchange_rates.refresh_api')" icon @mouseup.left="dbGetAPILayer()">
                                <v-icon>currency_exchange</v-icon>
                            </v-btn>
                            <bc-btn-add
                                v-if="hasPerm('exchange_rates.create')"
                                @invoke-method="invokeMethod($event)"
                                action="openExchangeRateForm"
                            ></bc-btn-add>
                            <bc-btn-refresh @invoke-method="dbGetExchangeRates(true)"></bc-btn-refresh>
                            <bc-search-menu :params="axiosParams">
                                <v-list>
                                    <v-list-tile>
                                        <bc-search-input v-model="filter.search" :params="axiosParams"></bc-search-input>
                                    </v-list-tile>
                                    <v-list-tile>
                                        <v-list-tile-action>
                                            <v-switch
                                                v-model="filter.is_active"
                                                color="success"
                                                :label="filter.is_active == '1' ? $t('lang.active') : $t('lang.inactive')"
                                                true-value="1"
                                                false-value="0"
                                            ></v-switch>
                                        </v-list-tile-action>
                                    </v-list-tile>
                                </v-list>
                            </bc-search-menu>
                            <bc-btn-mobile-nav @invoke-method="invokeMethod($event)" :mobile-list="mobile_list"></bc-btn-mobile-nav>
                        </v-toolbar>
                    </v-layout>
                </v-container>

                <v-card-text :class="$bp.smallScreen ? 'pa-0' : null">
                    <v-data-table :headers="headers" :items="exchange_rates" :no-data-text="$t('lang.no_results_matching')" hide-actions>
                        <template slot="items" slot-scope="props">
                            <tr class="clickable" @mouseup.left="openExchangeRateForm(props.item)">
                                <td>{{ props.item.from_currency_name }}</td>
                                <td>{{ props.item.to_currency_name }}</td>
                                <td>{{ props.item.rate }}</td>
                                <td>{{ props.item.date_created }}</td>
                                <td>
                                    <v-chip disabled round text-color="white" class="fs-14 text-center" :color="props.item.status_class">
                                        <span style="min-width: 60px">{{ props.item.status_display }}</span>
                                    </v-chip>
                                </td>
                            </tr>
                        </template>
                    </v-data-table>
                    <bc-pagination :page="page" :params="axiosParams" name="exchange_rates"></bc-pagination>
                </v-card-text>
            </v-card>

            <bc-dialog :value="exchange_rate_dialog">
                <v-card>
                    <v-form ref="form_exchange_rate">
                        <v-card-title>
                            <span class="headline">{{ exchange_rate.exchange_rate_id ? $t("lang.edit_exchange_rate") : $t("lang.add_exchange_rate") }}</span>
                            <v-spacer></v-spacer>
                            <bc-btn-dialog-close
                                @invoke-method="invokeMethod($event)"
                                action="closeExchangeRateDialog"
                                :dialog-status="exchange_rate_dialog"
                            ></bc-btn-dialog-close>
                        </v-card-title>
                        <v-card-text>
                            <v-container grid-list-form>
                                <v-layout row wrap>
                                    <v-flex xs12>
                                        <bc-autocomplete
                                            :focus="exchange_rate_dialog"
                                            v-model="exchange_rate.from_currency_id"
                                            :label="`${$t('lang.from_currency_id')} *`"
                                            :items="currencies"
                                            item-value="currency_id"
                                            item-text="name"
                                            :rules="ifValid('exchange_rates.from_currency_id')"
                                        ></bc-autocomplete>
                                    </v-flex>
                                    <v-flex xs12>
                                        <bc-autocomplete
                                            v-model="exchange_rate.to_currency_id"
                                            :label="`${$t('lang.to_currency_id')} *`"
                                            :items="currencies"
                                            item-value="currency_id"
                                            item-text="name"
                                            :rules="ifValid('exchange_rates.to_currency_id')"
                                        ></bc-autocomplete>
                                    </v-flex>
                                    <v-flex xs12>
                                        <v-text-field
                                            v-model="exchange_rate.rate"
                                            :label="`${$t('lang.rate')} *`"
                                            :counter="showCounter(exchange_rate.rate, 'exchange_rates.rate')"
                                            :rules="ifValid('exchange_rates.rate')"
                                        ></v-text-field>
                                    </v-flex>
                                </v-layout>
                            </v-container>
                        </v-card-text>
                        <v-card-actions>
                            <v-btn v-if="exchange_rate.exchange_rate_id" color="error" @mouseup.left="$refs.delete_exchange_rates.openDialog()">{{
                                $t("lang.delete")
                            }}</v-btn>
                            <v-spacer></v-spacer>
                            <v-btn flat @mouseup.left="closeExchangeRateDialog()">{{ $t("lang.cancel") }}</v-btn>
                            <v-btn color="success" @click="saveExchangeRates">{{ $t("lang.save") }}</v-btn>
                        </v-card-actions>
                    </v-form>
                </v-card>
            </bc-dialog>
            <delete-confirmation-dialog
                ref="delete_exchange_rates"
                :heading="$t('lang.delete_exchange_rate')"
                :message="$t('lang.confirm_delete_message')"
                @onConfirm="deleteExchangeRates(exchange_rate.exchange_rate_id)"
            ></delete-confirmation-dialog>
        </v-container>
    </div>
</template>

<script>
import { mapGetters, mapState, mapActions, mapMutations } from "vuex";
import { store } from "Store/store";

export default {
    data() {
        return {
            mobile_list: [
                { title: this.$t("lang.add_new"), action: "openExchangeRateForm" },
                { title: this.$t("lang.refresh"), action: "dbGetExchangeRates", params: [true] },
            ],
            headers: [
                { text: this.$t("lang.from_currency_id"), sortable: false, width: "30%" },
                { text: this.$t("lang.to_currency_id"), sortable: false, width: "30%" },
                { text: this.$t("lang.rate"), sortable: false, width: "20%" },
                { text: this.$t("lang.date_created"), sortable: false, width: "20%" },
                { text: this.$t("lang.status"), sortable: false, width: "20%" },
            ],
            enableAddModal: true,
            enableEditModal: true,

            exchange_rate: {},
            filter: {
                search: "",
                is_active: "1",
            },
            exchange_rate_dialog: false,
            dbGetExchangeRates: _.debounce(this.getExchangeRates, 1500, { maxWait: 1500, leading: true, trailing: false }),
            dbGetAPILayer: _.debounce(this.getApiLayer, 1500, { maxWait: 1500, leading: true, trailing: false }),
        };
    },
    beforeRouteEnter(to, from, next) {
        let parsedQuery = JSON.parse(JSON.stringify(to.query));
        store
            .dispatch("fetchExchangeRates", {
                body: parsedQuery,
            })
            .then((data) => {
                if (typeof data !== "undefined" && data.exchange_rates) {
                    next((vm) => {
                        vm.setQuery(parsedQuery, vm.filter, vm.default_filter);
                        vm.finishLoader();
                    });
                } else {
                    next({ name: "dashboard", replace: true });
                }
            });
    },
    beforeRouteUpdate(to, from, next) {
        let parsedQuery = JSON.parse(JSON.stringify(to.query));
        this.fetchExchangeRates({
            body: parsedQuery,
        }).then((data) => {
            if (typeof data !== "undefined" && data.exchange_rates) {
                this.setQuery(parsedQuery, this.filter, this.default_filter);
                this.finishLoader();
                next();
            } else {
                next({ name: "dashboard", replace: true });
            }
        });
    },
    computed: {
        ...mapState({
            default_filter: (state) => state.exchange_rates.exchange_rates_filter,
            page: (state) => state.exchange_rates.page,
            rules_exchange_rates: (state) => state.exchange_rates.rules_exchange_rates,
            exchange_rate_status_options: (state) => state.settings.exchange_rate_status_options,
            exchange_rates: (state) => state.exchange_rates.exchange_rates,
            currencies: (state) => state.currencies.currencies,
        }),
        axiosParams() {
            return this.prepareParams(this.filter, this.default_filter);
        },
    },
    methods: {
        ...mapActions(["fetchExchangeRates", "saveExchangeRate", "deleteExchangeRate", "fetchCurrencies", "fetchApiLayer"]),
        ...mapMutations(["validationOn", "validationOff", "toggleGlobalSnackbar", "toggleModalLoader"]),
        openExchangeRateForm(item = null) {
            if (item != null) {
                if (this.enableEditModal) {
                    if (this.customers == null) this.getCustomers();
                    if (this.$refs.form_exchange_rate) item ? this.$refs.form_exchange_rate.resetValidation() : this.$refs.form_exchange_rate.reset();

                    this.$nextTick(() => {
                        this.exchange_rate = item != null ? this.assignObj2(item, this.rules_exchange_rates) : {};
                        this.exchange_rate_dialog = true;
                    });
                } else {
                    this.$router.push({ name: "exchange_rate", params: { id: item.exchange_rate_id } });
                }
            } else {
                if (this.enableAddModal) {
                    if (this.customers == null) this.getCustomers();
                    if (this.$refs.form_exchange_rate) item ? this.$refs.form_exchange_rate.resetValidation() : this.$refs.form_exchange_rate.reset();
                    this.exchange_rate_dialog = true;
                } else {
                    this.$router.push({ name: "exchange_rate" });
                }
            }
        },
        saveExchangeRates() {
            this.validationOn();
            this.$nextTick(() => {
                if (this.validateForm("form_exchange_rate")) {
                    let body = this.prepForm(this.exchange_rate, this.rules_exchange_rates);

                    this.saveExchangeRate({
                        body: body,
                    }).then((data) => {
                        if (data && data.code == "200") {
                            if (this.enableEditModal) {
                                this.getExchangeRates();
                                this.closeExchangeRateDialog();
                            } else {
                                this.$router.push({ name: "exchange_rate", params: { id: data.exchange_rate_id } });
                            }
                        } else {
                            //this.toggleModalLoader(false);
                        }
                    });
                }
            });
        },
        deleteExchangeRates(id = null) {
            this.deleteExchangeRate({
                id: id,
            }).then((data) => {
                if (data && data.code == "200") {
                    this.getExchangeRates();
                    this.closeExchangeRateDialog();
                } else {
                    this.toggleModalLoader(false);
                }
            });
        },

        closeExchangeRateDialog() {
            this.exchange_rate_dialog = false;
            this.$refs.delete_exchange_rates.close();
            this.validationOff();
            this.toggleModalLoader(false);
        },
        getExchangeRates(pg_refresh = false) {
            this.startLoader();

            this.fetchExchangeRates({
                body: JSON.parse(JSON.stringify(this.$route.query)),
            })
                .then((data) => {
                    if (typeof data === "undefined") this.$router.push({ name: "dashboard" });
                })
                .finally(() => {
                    this.exchange_rate_dialog = false;
                    this.toggleModalLoader(false);
                    this.validationOff();
                    this.finishLoader(pg_refresh);
                });
        },
        getApiLayer() {
            this.startLoader();

            this.fetchApiLayer()
                .then((data) => {
                    if (typeof data === "undefined") this.$router.push({ name: "dashboard" });
                })
                .finally(() => {
                    this.getExchangeRates();
                    this.toggleModalLoader(false);
                    this.finishLoader();
                });
        },
        getCustomers() {
            this.$store
                .dispatch("fetchCustomers", {
                    url: "me/companies?module=people",
                    method: "get",
                })
                .then((data) => {
                    if (typeof data !== "undefined") {
                        this.customers = data.companies;
                    }
                });
        },
    },
    created() {
        this.fetchCurrencies({ body: { options: 1 } });
    },
};
</script>
